import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import TeamView from "../views/TeamView.vue";
import ItemCustomView from "../views/ItemCustomView.vue";
import StructureView from "../views/StructureView.vue";
import ArticlesListView from "../views/ArticlesListView.vue";
import ArticlesItemView from "../views/ArticlesItemView.vue";
import GalleriesListView from "../views/GalleriesListView.vue";
import GalleriesItemView from "../views/GalleriesItemView.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import WorkWithUsView from "../views/WorkWithUsView.vue";
import WorkWithUsResponseView from "../views/WorkWithUsResponseView.vue";
import RegistryView from "../views/RegistryView.vue";
import RegistryResponseView from "../views/RegistryResponseView.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import Error404View from "../views/Error404View.vue";
import CourseCustomView from "../views/CourseCustomView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: HomeView,
  },
  {
    name: "Equipe de apoio pedagógico",
    path: "/a-facem/equipe-de-apoio",
    component: TeamView,
  },
  {
    path: "/a-facem/estrutura",
    component: StructureView,
  },
  {
    path: "/a-facem/:item",
    component: ItemCustomView,
    meta: {
      mod: "school-pages",
    },
  },
  {
    path: "/academicos/:item",
    component: ItemCustomView,
    meta: {
      mod: "student",
    },
  },
  {
    path: "/cpa/:item",
    component: ItemCustomView,
    meta: {
      mod: "cpa",
    },
  },
  {
    path: "/pesquisa-e-extensao/:item",
    component: ItemCustomView,
    meta: {
      mod: "research",
    },
  },
  {
    path: "/processo-seletivo/:item",
    component: ItemCustomView,
    meta: {
      mod: "selection",
    },
  },
  {
    path: "/regulamentos/:item",
    component: ItemCustomView,
    meta: {
      mod: "regulations",
    },
  },
  {
    path: "/cursos/:item",
    component: CourseCustomView,
    meta: {
      mod: "courses",
    },
  },
  {
    name: "Notícias",
    path: "/noticias",
    component: ArticlesListView,
  },
  {
    name: "Notícia",
    path: "/noticias/:item",
    component: ArticlesItemView,
  },
  {
    name: "Galerias",
    path: "/galerias-de-fotos",
    component: GalleriesListView,
  },
  {
    name: "Galeria",
    path: "/galerias-de-fotos/:item",
    component: GalleriesItemView,
  },
  {
    name: "Fale Conosco",
    path: "/fale-conosco",
    component: ContactView,
  },
  {
    name: "Obrigado!",
    path: "/fale-conosco/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Trabalhe Conosco",
    path: "/trabalhe-conosco",
    component: WorkWithUsView,
  },
  {
    name: "Obrigado!",
    path: "/trabalhe-conosco/obrigado",
    component: WorkWithUsResponseView,
  },
  {
    name: "Matrícula",
    path: "/matricula",
    component: RegistryView,
  },
  {
    name: "Obrigado!",
    path: "/matricula/obrigado",
    component: RegistryResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
